import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  IPhonePropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/PhonePropertyTypeStrategy/types/IPhonePropertyTypeInterfaces'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'

export function usePhoneValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Input

  const fullValueToText = (value: IPhonePropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    return String(value?.phoneNumber || '')
  }

  const fullValueToInputValue = (value: IPhonePropertyTypeInterfaces['fullValue']) => {
    if(!value) {
      return null
    }
    return value.plain || ''
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: databaseProperties.map(databaseProperty => {
        return {
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty: null,
          operator: {
            type: FilterPropertyOperator.RegExp,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search.replace(/\s+/g, ''),
          },
          isDisabled: false,
        }
      }),
    }
  }

  const compareItemValues = (
    valueA: IPhonePropertyTypeInterfaces['fullValue'],
    valueB: IPhonePropertyTypeInterfaces['fullValue'],
    sortDirection: '1' | '-1',
  ): number => {
    const hasValueA = valueA && valueA.phoneNumber
    const hasValueB = valueB && valueB.phoneNumber
    
    if (!hasValueA && !hasValueB) return 0
    if (!hasValueA) return 1
    if (!hasValueB) return -1
    
    const phoneA = String(valueA.phoneNumber || '')
    const phoneB = String(valueB.phoneNumber || '')
    const comparison = phoneA.localeCompare(phoneB)
    
    return sortDirection === '1' ? comparison : -comparison
  }

  return $$({
    fullValueToText,
    fullValueToInputValue,
    strategyComponentType,
    searchToFilterQuery,
    compareItemValues,
  })
}
